import { Slot } from "@radix-ui/react-slot";
import { cn } from "@scott/ui/client";
import type { ImgHTMLAttributes } from "react";

interface BikingIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  asChild?: boolean;
}

const BikingIcon = ({ className, asChild = false }: BikingIconProps) => {
  const Comp = asChild ? Slot : "svg";
  return (
    <Comp
      className={cn(className)}
      fill="none"
      height="16"
      viewBox="0 0 640 640"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M400 160C426.5 160 448 138.5 448 112C448 85.5 426.5 64 400 64C373.5 64 352 85.5 352 112C352 138.5 373.5 160 400 160zM427.2 224L365.4 175.2C348.1 161.6 323.7 161.4 306.3 174.9L223.2 239.1C192.5 262.9 194.7 309.9 227.5 330.7L288 369.1L288 480C288 497.7 302.3 512 320 512C337.7 512 352 497.7 352 480L352 352C352 341.3 346.7 331.3 337.8 325.4L295 296.9L355.3 248.4L396 281C401.7 285.5 408.7 288 416 288L480 288C497.7 288 512 273.7 512 256C512 238.3 497.7 224 480 224L427.2 224zM144 576C205.9 576 256 525.9 256 464C256 402.1 205.9 352 144 352C82.1 352 32 402.1 32 464C32 525.9 82.1 576 144 576zM496 576C557.9 576 608 525.9 608 464C608 402.1 557.9 352 496 352C434.1 352 384 402.1 384 464C384 525.9 434.1 576 496 576z"
        fill="#74828b"
      />
    </Comp>
  );
};

BikingIcon.displayName = "BikingIcon";

export { BikingIcon };
